
import  VectorSource  from 'ol/source/Vector';
import  VectorLayer  from 'ol/layer/Vector';
 

// no basemap layer displayed.
export  const noBasemapLayer  =   new VectorLayer({source: new VectorSource(), visible: false,});

